import { IntlShape } from 'react-intl';
import { formatTranslation, type TranslatedString } from 'intl';
import { FileTranslationKeys, NotificationTranslationKeys } from 'intl/keys';

export const getNoPermissionTitle = (intl: IntlShape): TranslatedString =>
  formatTranslation(intl, NotificationTranslationKeys.actionForbidden,);

export const getFileTypeNotSupportedForGraphicOperationTitle = (
  intl: IntlShape
): TranslatedString =>
  formatTranslation(intl, FileTranslationKeys.fileTypeNotSupportedForGraphicOperation,);

export const getPendingConversionPdfTitle = (intl: IntlShape): TranslatedString =>
  formatTranslation(intl, FileTranslationKeys.imageConvertInfoPending,);
